<script setup>
const honeypotRef = ref(null);

const defaultForm = {
  name: "",
  email: "",
  phone: "",
  message: "",
};

const form = ref({
  ...defaultForm,
});

const status = ref(null);

async function submitForm() {
  if (!honeypotRef.value.validate()) {
    return false;
  }

  emit("submitted", form.value);
}

const clearForm = () => {
  form.value = { ...defaultForm };
};
const emit = defineEmits("submitted");

defineExpose({
  status,
  clearForm,
});
</script>

<template>
  <form @submit.prevent class="space-y-6">
    <div class="flex flex-row justify-between items-center">
      <h1
        class="text-3xl font-bold font-iq-header leading-iq-header tracking-iq-header text-iq-header-color"
      >
        Kontakt
      </h1>

      <a
        href="tel:+48600785127"
        class="uppercase inline-flex items-center rounded-iq-roundness hover:scale-125 bg-accent-500 font-bold md:text-3xl transition hover:text-iq-secondary"
      >
        <Icon name="i-heroicons-phone-solid" class="mr-2" />
        600 785 127
      </a>
    </div>
    <p
      class="mt-2 text-lg text-justify font-iq-paragraph leading-iq-paragraph tracking-iq-paragraph text-iq-paragraph-color"
    >
      Wyślij do nas formularz, a my skontaktujemy się, aby dopracować szczegóły i stworzyć
      ofertę skrojoną na miarę.
    </p>

    <!-- Grupa: Imię, Nazwisko -->
    <div class="grid grid-cols-1 gap-y-6 gap-x-8">
      <div>
        <label for="firstName" class="block text-sm font-medium text-gray-700"
          >Imię</label
        >
        <input
          type="text"
          id="firstName"
          name="firstName"
          v-model="form.name"
          required
          class="mt-1 block w-full rounded-iq-roundness border border-gray-300 bg-gray-50 py-2 px-4 text-gray-900 placeholder-gray-400 shadow-sm transition focus:border-iq-primary focus:bg-white focus:ring-2 focus:ring-iq-primary/50"
          placeholder="Jan"
        />
      </div>
    </div>

    <!-- Grupa: E-mail, Telefon -->
    <div class="grid grid-cols-1 gap-y-6 gap-x-8 sm:grid-cols-2">
      <div>
        <label for="email" class="block text-sm font-medium text-gray-700"
          >Adres e-mail</label
        >
        <input
          type="email"
          id="email"
          v-model="form.email"
          name="email"
          required
          class="mt-1 block w-full rounded-iq-roundness border border-gray-300 bg-gray-50 py-2 px-4 text-gray-900 placeholder-gray-400 shadow-sm transition focus:border-iq-primary focus:bg-white focus:ring-2 focus:ring-iq-primary/50"
          placeholder="jan.kowalski@mail.com"
        />
      </div>
      <div>
        <label for="phone" class="block text-sm font-medium text-gray-700">Telefon</label>
        <input
          type="tel"
          id="phone"
          name="phone"
          v-model="form.phone"
          required
          class="mt-1 block w-full rounded-iq-roundness border border-gray-300 bg-gray-50 py-2 px-4 text-gray-900 placeholder-gray-400 shadow-sm transition focus:border-iq-primary focus:bg-white focus:ring-2 focus:ring-iq-primary/50"
          placeholder="+48 600 785 127"
        />
      </div>
    </div>

    <!-- Uwagi -->
    <div>
      <label for="message" class="block text-sm font-medium text-gray-700"
        >Wiadomość</label
      >
      <textarea
        id="message"
        name="message"
        v-model="form.message"
        rows="4"
        class="mt-1 block w-full rounded-iq-roundness border border-gray-300 bg-gray-50 py-2 px-4 text-gray-900 placeholder-gray-400 shadow-sm transition focus:border-iq-primary focus:bg-white focus:ring-2 focus:ring-iq-primary/50 resize-none"
        placeholder="Np. przyjazd po godz. 24:00, specjalne potrzeby itp."
      ></textarea>
    </div>

    <FlexuilibHoney ref="honeypotRef" displayMessage />

    <!-- Przycisk wyślij -->
    <div class="pt-4">
      <button type="submit" class="iq-cta w-full" @click="submitForm">
        Wyślij zapytanie
      </button>
    </div>

    <FlexuilibFormStatus :status="status" />
  </form>
</template>
